import { render, staticRenderFns } from "./Before.vue?vue&type=template&id=784abb25&scoped=true&"
import script from "./Before.vue?vue&type=script&lang=js&"
export * from "./Before.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784abb25",
  null
  
)

export default component.exports